var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 239 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.759745 0.479421C0.54456 0.759162 0.596892 1.16038 0.876633 1.37556L5.75647 5.12929L0.876633 8.88301C0.596892 9.09819 0.54456 9.49941 0.759745 9.77915C0.97493 10.0589 1.37615 10.1112 1.65589 9.89604L6.75522 5.97348L6.36559 5.46696L6.75522 5.97348C7.30946 5.54714 7.30946 4.71143 6.75522 4.28509L6.36559 4.79161L6.75522 4.28509L1.65589 0.362533C1.37615 0.147348 0.97493 0.199681 0.759745 0.479421Z",
    fill: "#666666"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.d4b7e997fbd5539023c819fc4a0536bd.svg";
export { ForwardRef as ReactComponent };